import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../App';

import { BACKEND_URL } from "../utils/apiBase";
const API = `${BACKEND_URL}/api`;

// Handles the return trip from Emergent-managed Google Sign-In.
const AuthCallback = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = location.hash?.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const role = searchParams.get('role');
    const redirectPath = searchParams.get('redirect');

    if (!sessionId) {
      setError('Missing Google sign-in session. Please try again.');
      setTimeout(() => navigate('/login'), 1500);
      return;
    }

    const exchange = async () => {
      try {
        const resp = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
          role
        });
        const { access_token, user } = resp.data;
        login(user, access_token);

        // Re-attach any anonymous Free Checkup started before sign-in
        const pendingCheckupId = localStorage.getItem('fv_pending_checkup');
        if (pendingCheckupId) {
          try {
            await axios.post(`${API}/checkups/${pendingCheckupId}/attach`, {}, {
              headers: { Authorization: `Bearer ${access_token}` }
            });
          } catch (attachErr) {
            console.warn('Post-login checkup attach failed:', attachErr?.response?.data || attachErr);
          }
          localStorage.removeItem('fv_pending_checkup');
        }

        if (redirectPath) {
          navigate(redirectPath, { replace: true });
        } else if (user.role === 'professional') {
          navigate('/professional', { replace: true });
        } else {
          navigate('/individual', { replace: true });
        }
      } catch (err) {
        setError(err.response?.data?.detail || 'Google sign-in failed. Please try again.');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    exchange();
  }, [location.hash, searchParams, navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100" data-testid="auth-callback-loading">
      {error ? (
        <p className="text-red-600 font-medium">{error}</p>
      ) : (
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      )}
    </div>
  );
};

export default AuthCallback;
